import * as tabContentKeys from "../enums/tabContentKeys";
import isProfileBinder from "./binder/isProfileBinder";

function unknowProfileTab(tabContent) {
	return (
		!tabContent ||
		!tabContent.library_name ||
		!tabContent.profile_type ||
		tabContent.profile_id === null ||
		tabContent.profile_id === undefined
	);
}

// NOTE(CK): Profile binders specify edit_criterion_name and edit_joinpath_name in the root tab
// object. We cannot set this field through the API for non-profile binders, so this function will
// put those fields into tab.content if present on the tab object.
export default function copyBinderTab(
	tab,
	binderType,
	profileLibrary,
	profileId,
	isReduxTab = false,
) {
	const editKey = isReduxTab ? "editCriterionName" : "edit_criterion_name";
	const joinpathKey = isReduxTab ? "editJoinpathName" : "edit_joinpath_name";

	let requiredCriterion =
		tab.content && tab.content[tabContentKeys.REQUIRED_CRITERION]
			? tab.content[tabContentKeys.REQUIRED_CRITERION]
			: {};
	if (tab[editKey] && !tab.content) {
		requiredCriterion = {
			required_criterion: {
				name: tab[editKey],
				joinpath_name: tab[joinpathKey],
				criterion: null,
			},
		};
	}

	if (tab.search || !isProfileBinder(binderType) || !unknowProfileTab(tab.content)) {
		return {
			...tab,
			content: {
				...tab.content,
				...requiredCriterion,
			},
		};
	}

	return {
		...tab,
		content: {
			...tab.content,
			...requiredCriterion,
			library_name: profileLibrary,
			profile_type: binderType,
			profile_id: profileId,
		},
	};
}
